import { render, staticRenderFns } from "./ElCollapseV2.vue?vue&type=template&id=51578fb2"
import script from "./ElCollapseV2.vue?vue&type=script&lang=js"
export * from "./ElCollapseV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports